// extracted by mini-css-extract-plugin
module.exports = {"subcatTitle":"SpringboardCarouselTile_subcatTitle__e0_oA","smallTile":"SpringboardCarouselTile_smallTile__aka76"};